import { render, staticRenderFns } from "./standardItemText.vue?vue&type=template&id=78ed3bb0&"
import script from "./standardItemText.vue?vue&type=script&lang=js&"
export * from "./standardItemText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports